var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ninaadmintextlogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.86,
    height: 20,
    viewBox: "0 0 84.86 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ninatextlogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M113.209,31.485v9.5a.178.178,0,0,1-.185.185h-.339c-.247,0-.524-.185-.863-.555l-5.735-6.567v6.937a.178.178,0,0,1-.185.185h-.987a.211.211,0,0,1-.216-.216V31.516a.178.178,0,0,1,.185-.185h.586c.123,0,.185.062.277.154l6.074,7.091V31.485a.178.178,0,0,1,.185-.185h.987a.206.206,0,0,1,.216.185",
    transform: "translate(-104.7 -31.238)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M146.472,31.3a.178.178,0,0,1,.185.185V40.95c0,.123-.062.216-.185.216h-.956a.211.211,0,0,1-.216-.216V31.516a.164.164,0,0,1,.185-.185h.987Z",
    transform: "translate(-132.782 -31.238)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M171.409,31.485v9.5a.178.178,0,0,1-.185.185h-.339c-.247,0-.524-.185-.863-.555l-5.735-6.567v6.937a.178.178,0,0,1-.185.185h-.987a.211.211,0,0,1-.216-.216V31.516a.178.178,0,0,1,.185-.185h.586c.123,0,.185.062.277.154l6.074,7.091V31.485a.178.178,0,0,1,.185-.185h.987a.206.206,0,0,1,.216.185",
    transform: "translate(-144.956 -31.238)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M208.883,38.068l-2.1-4.409-2.066,4.409Zm2.682,2.991h-1.11a.222.222,0,0,1-.216-.123l-.74-1.6h-5.334l-.74,1.6a.233.233,0,0,1-.216.123h-1.141c-.123,0-.185-.092-.123-.216l4.625-9.619a.157.157,0,0,1,.154-.123h.154a.157.157,0,0,1,.154.123l4.625,9.619a.122.122,0,0,1-.092.216",
    transform: "translate(-171.947 -31.1)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M252.846,36.171a4.047,4.047,0,0,0-4.255-4.224h-2.744l.031,8.633h2.744a4.224,4.224,0,0,0,4.224-4.409m.647,0a4.771,4.771,0,0,1-4.964,4.995h-3.206a.113.113,0,0,1-.123-.123V31.423c0-.092.031-.123.123-.123H248.5a4.717,4.717,0,0,1,4.995,4.871",
    transform: "translate(-201.882 -31.238)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M290.142,38.445l-2.96-6.259-2.96,6.259Zm1.85,2.682H291.5c-.062,0-.123-.031-.123-.092l-.925-1.973h-6.475l-.925,1.973c-.031.062-.062.092-.123.092h-.493c-.062,0-.092-.062-.062-.123L287,31.292a.115.115,0,0,1,.123-.092h.185c.062,0,.092,0,.123.092L292.054,41c.031.062,0,.123-.062.123",
    transform: "translate(-227.585 -31.169)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M326.722,31.5v.37c0,.092-.031.123-.123.123h-3.114v9.126c0,.092-.031.123-.123.123h-.308c-.154,0-.216-.092-.216-.247v-9h-3.114c-.092,0-.123-.031-.123-.123V31.5a.113.113,0,0,1,.123-.123H326.6c.062-.031.123,0,.123.123",
    transform: "translate(-253.343 -31.283)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M356.242,38.445l-2.96-6.259-2.96,6.259Zm1.85,2.682H357.6c-.062,0-.123-.031-.123-.092l-.925-1.973h-6.475l-.925,1.973c-.031.062-.062.092-.123.092h-.493c-.062,0-.092-.062-.062-.123l4.625-9.712a.115.115,0,0,1,.123-.092h.185c.062,0,.092,0,.123.092L358.154,41c.031.062,0,.123-.062.123",
    transform: "translate(-273.306 -31.169)",
    fill: "#1d1d1b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M-28.9-1.318h-2.312L-31.654,0h-1.4l2.382-6.4h1.222l2.4,6.4h-1.4Zm-1.956-1.068h1.6l-.8-2.4ZM-25.38,0V-6.4h1.969a2.99,2.99,0,0,1,1.51.38,2.651,2.651,0,0,1,1.039,1.081,3.334,3.334,0,0,1,.374,1.593v.294a3.344,3.344,0,0,1-.367,1.586A2.628,2.628,0,0,1-21.89-.387,3.012,3.012,0,0,1-23.4,0Zm1.318-5.331v4.271h.637a1.432,1.432,0,0,0,1.182-.505,2.284,2.284,0,0,0,.417-1.446v-.338a2.32,2.32,0,0,0-.4-1.479,1.427,1.427,0,0,0-1.182-.5ZM-16.728-6.4l1.644,4.641L-13.45-6.4h1.731V0h-1.323V-1.749l.132-3.019L-14.636,0h-.905l-1.723-4.764.132,3.015V0h-1.318V-6.4ZM-8.085,0H-9.4V-6.4h1.318Zm7.5,0H-1.9L-4.465-4.21V0H-5.783V-6.4h1.318L-1.894-2.18V-6.4H-.58Z",
    transform: "translate(85 20)",
    fill: "#1d1d1b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/LogoText.b97b0e093c93ec3e35ae5ae9a7b56408.svg";
export { ForwardRef as ReactComponent };